import React from "react";
import "./Terms-and-Conditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions">
      <div className="container">
        <div className="header">
          <h1>Terms and Conditions</h1>
          <p className="effective-date">Effective Date: 01/10/2025</p>
        </div>

        <div className="content">
          <section className="introduction">
            <p>
              These Terms and Conditions ("Agreement") set forth the general
              terms and conditions for your use of the Education Planner website
              ("Website" or "Service") and any of its related products and
              services (collectively, "Services"). This Agreement is legally
              binding between you ("User", "you", or "your") and Education
              Planner ("Operator", "we", "us", or "our").
            </p>
            <p>
              By accessing or using the Website and Services, you confirm that
              you have read, understood, and agree to comply with the terms of
              this Agreement. If you are using our Services on behalf of a
              business or other legal entity, you represent that you have the
              authority to bind such entity to this Agreement. If you do not
              agree to these terms, you must not use the Website or Services.
            </p>
            <p>
              This Agreement is published in compliance with Rule 3(1) of the
              Information Technology (Intermediary Guidelines and Digital Media
              Ethics Code) Rules, 2021.
            </p>
          </section>

          <section className="program-availability">
            <h2>Program Availability Disclaimer</h2>
            <p>
              Education Planner strives to provide accurate and up-to-date
              information regarding program status (open, closed, or
              waitlisted). However, please note that such information may not
              always be updated in real-time due to:
            </p>
            <ul>
              <li>Human error,</li>
              <li>Delays in updates from institutions,</li>
              <li>High demand and rapid seat allocation, or</li>
              <li>Any other unforeseen reasons.</li>
            </ul>
            <p>
              Education Planner shall not be held responsible or liable for any
              discrepancies in program availability status. Users are strongly
              advised to verify directly with the respective institution before
              making decisions.
            </p>
          </section>

          <section className="links-to-resources">
            <h2>Links to Other Resources</h2>
            <p>
              Our Website and Services may contain links to third-party websites
              or applications. Such links are provided for convenience only.
              Unless explicitly stated, Education Planner does not endorse,
              sponsor, or associate with these resources.
            </p>
            <p>
              We are not responsible for examining, evaluating, or guaranteeing
              the accuracy, safety, or quality of third-party offerings. Any
              access to third-party sites is entirely at your own risk.
            </p>
          </section>

          <section className="prohibited-uses">
            <h2>Prohibited Uses</h2>
            <p>
              You agree not to use the Website or Services for any unlawful or
              unauthorized purposes, including but not limited to:
            </p>
            <ul>
              <li>Violating any applicable laws or regulations.</li>
              <li>Infringing intellectual property rights.</li>
              <li>Uploading malicious code, viruses, or harmful content.</li>
              <li>Harassing, defaming, or discriminating against others.</li>
              <li>Submitting false, misleading, or fraudulent information.</li>
              <li>Spamming, phishing, scraping, or similar activities.</li>
              <li>
                Interfering with the security or functionality of the Website or
                Services.
              </li>
            </ul>
            <p>
              We reserve the right to suspend or terminate your access if you
              violate these conditions.
            </p>
          </section>

          <section className="intellectual-property">
            <h2>Intellectual Property Rights</h2>
            <p>
              All content, trademarks, service marks, graphics, and logos used
              in connection with Education Planner are the exclusive property of
              Education Planner or its licensors. Your use of the Website does
              not grant you any right or license to reproduce, distribute, or
              otherwise exploit any intellectual property without prior written
              permission.
            </p>
          </section>

          <section className="limitation-liability">
            <h2>Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Education Planner, its
              affiliates, officers, employees, and partners shall not be liable
              for any indirect, incidental, special, or consequential damages,
              including but not limited to:
            </p>
            <ul>
              <li>Loss of profits, revenue, or business opportunities,</li>
              <li>Errors in program information,</li>
              <li>Business interruptions or delays,</li>
              <li>Reliance on outdated or inaccurate program listings.</li>
            </ul>
            <p>
              Our aggregate liability, if any, shall not exceed the amount
              actually paid by you (if any) to the Education Planner for using
              the Services in the month prior to the claim.
            </p>
          </section>

          <section className="indemnification">
            <h2>Indemnification</h2>
            <p>
              You agree to indemnify and hold Education Planner, its affiliates,
              officers, employees, and partners harmless from any claims,
              damages, or expenses arising from:
            </p>
            <ul>
              <li>Your use of the Website or Services,</li>
              <li>Your violation of these Terms, or</li>
              <li>Your infringement of third-party rights.</li>
            </ul>
          </section>

          <section className="severability">
            <h2>Severability</h2>
            <p>
              If any provision of this Agreement is found unenforceable, the
              remaining provisions shall continue to remain valid and
              enforceable.
            </p>
          </section>

          <section className="dispute-resolution">
            <h2>Dispute Resolution</h2>
            <p>
              This Agreement shall be governed by the laws of Punjab, India. Any
              disputes shall be subject to the exclusive jurisdiction of the
              courts in Punjab, India.
            </p>
          </section>

          <section className="changes-amendments">
            <h2>Changes and Amendments</h2>
            <p>
              Education Planner reserves the right to update or modify these
              Terms at any time. The revised version will be effective
              immediately upon posting on the Website. Continued use of the
              Services after such updates constitutes acceptance of the revised
              Terms.
            </p>
          </section>

          <section className="acceptance-terms">
            <h2>Acceptance of Terms</h2>
            <p>
              By using our Website and Services, you acknowledge that you have
              read, understood, and agree to these Terms and Conditions. If you
              do not agree, you must immediately discontinue use of the Website.
            </p>
          </section>

          <section className="contact-us">
            <h2>Contact Us</h2>
            <p>
              For any questions regarding these Terms and Conditions, please
              contact us:
            </p>
            <p className="contact-email">📧 support@educationplanner.io</p>
          </section>

          <div className="payment-refund-policy">
            <h2>Payment and Refund Policy</h2>
            <p>
              This section will contain the payment and refund policy details.
              Please refer to our separate Payment and Refund Policy document
              for complete information.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
